<template>
  <div class="w-full bg-white rounded-lg my-4 p-4 text-sm border"
       @click="updateSurvey"
       @touchstart="toggleAnimation"
       @touchend="toggleAnimation">
    <div class="grid grid-cols-2">
      <div class="flex items-center">
        <OfficeBuildingIcon class="h-5 w-5 ml-1 text-green-400"/>
        {{ survey.shop.name }}
      </div>

      <div class="flex">
        <PhoneIcon class="h-5 w-5 ml-1 text-green-400"/>
        {{ survey.shop.phone }}
      </div>

      <div class="flex mt-2">
        <InformationCircleIcon class="h-5 w-5 ml-1 text-green-400"/>
        <span style="direction: ltr">{{ survey.shop.type }}</span>
      </div>

      <div class="flex mt-2">
        <ClockIcon class="h-5 w-5 ml-1 text-green-400"/>
        <span style="direction: ltr">{{ survey.datetime }}</span>
      </div>
    </div>

    <div class="flex mt-2">
      <LocationMarkerIcon class="h-5 w-5 ml-1 text-green-400"/>
      <span>آدرس:</span>
      {{ survey.shop.address }}
    </div>
  </div>
</template>
<script>
import {
  ClockIcon,
  InformationCircleIcon,
  LocationMarkerIcon,
  OfficeBuildingIcon,
  PhoneIcon
} from "@heroicons/vue/outline";

export default {
  name: 'HistoryCard',
  components: {LocationMarkerIcon, ClockIcon, InformationCircleIcon, PhoneIcon, OfficeBuildingIcon},
  props: ['survey', 'index'],
  data() {
    return {
      editSurvey: {}
    }
  },
  created() {
    this.editSurvey = this.survey
  },
  methods: {
    // updateSurvey() {
    //   this.editSurvey.editIndex = this.index
    //   this.$store.dispatch('editSurvey', this.editSurvey)
    //   this.$router.push('/survey/shop-info')
    // },
    toggleAnimation(event) {
      event.currentTarget.classList.toggle('border-green-500')
    }
  }
}
</script>
